export default "__VITE_ASSET__3054d4e6__"